import { LeftContainersPage } from "@/features/delivery-order-batch/pages/LeftContainersPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/delivery-order-batch/$deliveryOrderBatchID/left-containers",
)({
	component: LeftContainersPage,
	validateSearch: (
		search: Record<string, unknown>,
	): { transferOrderID?: string } => ({
		transferOrderID:
			typeof search.transferOrderID === "string"
				? search.transferOrderID
				: undefined,
	}),
});
